// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1W_MG","paramInput":"JobSimulator_paramInput__Sxs18","input":"JobSimulator_input__1NKvK"};